import { TCardTypeCard } from 'types/cardTypeMessage';
import { CardTypeMessagePicturesCarouselShell } from './CardTypeMessagePicturesCarouselShell';

type Props = {
  cards: TCardTypeCard[];
};

export function CardTypeMessagePicturesInlineCarousel({ cards }: Props) {
  return (
    <CardTypeMessagePicturesCarouselShell
      cards={cards}
      variant="inline"
      className="min-w-0 max-w-[260px]"
    />
  );
}
